export default __webpack_public_path__ + "static/media/icon_J.e199e9ff.svg";